import asArray from 'utils/arrays/asArray.util';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import fromAnyToNumber from 'utils/converters/fromAnyToNumber.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import replaceNaN from 'utils/values/replaceNaN.util';

const fromInitReaderPaymentToDto = (item) => {
  if (item === null || item === void 1) return item;

  const amountBeforeTax = typeof item.amountBeforeTax === 'number' ? replaceNaN(null, fromAnyToNumber(item.amountBeforeTax)) : undefined;

  return {
    // most fields are required to be present in the body, so they have fallback of null
    items: asArray(item.items),
    appointment_id: fromAnyToInteger(item.appointmentId) || null,
    client_id: fromAnyToInteger(item.clientId) || null,
    payment_intent: fromAnyToString(item.paymentIntentId) || null,
    payment_origin: fromAnyToString(item.paymentOrigin) || null,
    amount_to_charge: replaceNaN(null, fromAnyToNumber(item.amount)),
    amount_to_charge_before_tax_and_tips: amountBeforeTax,
  };
};

// noinspection JSUnusedGlobalSymbols
export default fromInitReaderPaymentToDto;
